const galleryId = 42;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_93206026.jpg","sh_1276662937.jpg","sh_1082441399.jpg","sh_1254136153.jpg","sh_1082441402.jpg","sh_1254163027.jpg","sh_1213923499.jpg","sh_1156066513.jpg","sh_1309934509.jpg","sh_176391974.jpg","sh_1524366266.jpg","sh_1342756181.jpg","sh_753073714.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Root canal treatment procedure'));

group = ["sh_124420099.jpg","sh_1854590953.jpg","sh_1605528283.jpg","sh_124420096.jpg","sh_1731466111.jpg","sh_1780338797.jpg","sh_1237960804.jpg","sh_123309112.jpg","sh_1605528343.jpg","sh_1755456770.jpg","sh_1237960783.jpg","sh_1237960768.jpg","sh_793537159.jpg","sh_1237960810.jpg"];
group.forEach((i) => addItemToGroup(i, '2. During/After treatment'));

group = [];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
